import React from 'react';

export const getDuration= (fromString,toString)=>{
    const from=new Date(fromString);
    const to=new Date(toString);
    console.log(from)
    console.log(to)
    return getTimeObject(Math.abs(to-from));
};


export const getTimeObject=(time)=>{
    console.log(time)
    const h=Math.floor(time/3600000);
    time-=h*3600000;
    const min=Math.floor(time/60000);
    time-=min*60000;
    const sec=Math.floor(time/1000);
    return{
        h:h,
        m:min,
        s:sec
    }
};

export const getTimeString=(duration)=>{
    let res = duration.h && ! isNaN(duration.h)? duration.h+'ч.':' ';
    res +=  duration.m && ! isNaN(duration.m) ?duration.m +'мин.':'';
    res += duration.s && ! isNaN(duration.s)?duration.s+'c.':'';
    return res;
}

export const getTimeObjectJsx=(duration)=>(
    <p> {duration.h && ! isNaN(duration.h)? duration.h+'ч.':'' }
        {duration.m && ! isNaN(duration.m) ?duration.m +'мин.':''}
        {duration.s && ! isNaN(duration.s)?duration.s+'c.':''}</p>
);

export const getDurationJsx=(fromString,toString)=>{
    return getTimeObjectJsx(getDuration(fromString,toString));
};

export const getTimesJsx=(time)=>{
    return getTimeObjectJsx(getTimeObject(time));
};